import React from "react"

export default function XSVG (props){
    return (
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.06007 5.5L11.4903 8.93021L9.43021 10.9903L6 7.56007L2.56007 11L0.5 8.93993L3.93993 5.5L0.5 2.06007L2.56007 0L6 3.43993L9.43993 0.00971707L11.5 2.06979L8.06007 5.5Z" fill="#F36D6D"/>
        </svg>
    );
}

